import { useWidgetData } from '../useWidgetData'

import { StatisticWidget } from '../../../types/widget/widget'

export const useMonthlyActivityWidget = () =>
  useWidgetData<StatisticWidget>('monthly-activity')
